angular.module('app').controller('MoodCtrl', function($controller, $http, $scope, Upload, appUtils) {
    "ngInject";

    var main = this;

    main.name = 'mood';
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.uploadFile = function(file) {
        main.uploading = true;
        $http({
            'method': 'POST',
            'url': '/api/v1/admin/mood/upload'
        }).then(
            function(response) {
                appUtils.fileReaderUpload(
                    response.data.upload_url, 'audio/mpeg', file
                ).then(
                    function() {
                        main.uploading = false;
                        main.item.song = response.data.filename;
                    }
                );
            }
        );
    };

    $scope.$on('model-loaded', function() {
        main.item.ms_per_photo = main.item.ms_per_photo / 1000;
    });

    main.save = function() {
        main.item.ms_per_photo = main.item.ms_per_photo *1000;
        main._save();
    };
});
